import fontsConfig from './fonts.json';

/**
 * Get the proper font family CSS value for a font name
 * @param {string} fontName - The font name (e.g., "Arial", "Times New Roman")
 * @returns {string} - The CSS font-family value (e.g., "Arial, sans-serif")
 */
export function getFontFamilyValue(fontName) {
  const font = fontsConfig.supportedFonts.find((f) => f.name === fontName);
  return font ? font.family : fontName; // Fallback to fontName if not found
}

/**
 * Get all supported font names
 * @returns {string[]} - Array of font names
 */
export function getSupportedFontNames() {
  return fontsConfig.supportedFonts.map((font) => font.name);
}

/**
 * Get fonts grouped by category
 * @returns {Object} - Fonts organized by category
 */
export function getFontsByCategory() {
  const fontsByCategory = {};

  fontsConfig.supportedFonts.forEach((font) => {
    if (!fontsByCategory[font.category]) {
      fontsByCategory[font.category] = [];
    }
    fontsByCategory[font.category].push(font);
  });

  return fontsByCategory;
}

/**
 * Get popular fonts (most commonly used)
 * @returns {Object[]} - Array of popular fonts
 */
export function getPopularFonts() {
  const popularFontNames = [];

  // Collect popular fonts from each category
  Object.values(fontsConfig.categories).forEach((category) => {
    if (category.popular) {
      popularFontNames.push(...category.popular);
    }
  });

  // Remove duplicates and get font objects
  const uniquePopularNames = [...new Set(popularFontNames)];
  return fontsConfig.supportedFonts.filter((font) => uniquePopularNames.includes(font.name));
}

/**
 * Get the default font name
 * @returns {string} - Default font name
 */
export function getDefaultFontName() {
  return fontsConfig.defaultFont;
}
